import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../lib/utils';
import Modal from '../common/Modal/Modal';
import KPI_INFO from '../../constants/kpiInfo';
import {trackUserClick} from '@forwardfinancing/analytics-frontend-library';

const DisplayMessages = {
  submissions_count: '# Submissions',
  approval_count: '# Approvals',
  approval_dollars: '$ Approved',
  funded_dollars: '$ Funded',
  funded_count: '# Funded',
  average_deal_size: 'Average Deal Size',
  auto_decline_rate: 'Auto Decline Rate',
  approval_rate: 'Approval Rate',
  conversion_rate: 'Conversion Rate',
  booking_rate: 'Booking Rate'
};

export class SubmissionsKpiDataList extends React.Component {
  constructor(props) {
    super(props);

    const dates = utils.getMomentEndAndStartDateByMonth(
      utils.getMomentDateByKey('currentDate').format('YYYY-MM-DD')
    );

    this.state = {
      dateRange: {
        start: dates.start,
        end: dates.end
      },
      infoModalOpen: false
    };
  }

  openInfoModal(){
    trackUserClick({attribute: 'About KPIs'});
    this.setState({infoModalOpen: true});
  }

  handleInfoClose(){
    this.setState({infoModalOpen: false});
  }

  areAllAccurate(submissionsData) {
    const accuracyData = Object.keys(DisplayMessages).map((key) => {
      return submissionsData[key].goal_accurate;
    });
    return !accuracyData.includes(false);
  }

  classToAssignForGoalCompare(pace, allAccurate, type) {
    if (allAccurate && type === 'New') {
      switch (pace) {
        case -1:
          return 'below-pace';
        case 1:
          return 'above-pace';
        case 0:
          return 'on-pace';
        default:
          return 'no-pace';
      }
    } else {
      return 'no-pace';
    }
  }

  renderExplanatoryText() {
    return (
      <p className="is-small">
        <span className="g">
          {`Green\u00a0`}
        </span>
        <span>
          {`indicates outperforming goal;\u00a0`}
        </span>
        <span className="r">
          {'Red\u00a0'}
        </span>
        <span>
          {`indicates underperforming goal;\u00a0`}
        </span>
        <span className="b">
          {`Black\u00a0`}
        </span>
        <span>
          {`indicates performance in line with goal.\u00a0`}
        </span>
      </p>
    );
  }

  renderData(){
    const { submissions, submissionsType } = this.props;
    const allAccurate = this.areAllAccurate(submissions);
    return (
      <div className="submissions-kpi-data-list__content">
        <ul className="list">
          {Object.keys(DisplayMessages).map((key, i) => {
            const classToAssign = this.classToAssignForGoalCompare(
              submissions[key].pace,
              allAccurate,
              submissionsType
            );
            return (
              <li
                className={`list-item ${i}`}
                key={i}
              >
                <span className="key">
                  {DisplayMessages[key]}
                </span>
                <span className={`data ${classToAssign}`}>
                  {submissions[key].value}
                </span>
              </li>
            );
          })}
        </ul>
        <button
          className="link-to-info-modal button is-small is-light"
          onClick={this.openInfoModal.bind(this)}
        >
          {`About KPI's`}
        </button>
        <Modal
          isActive={this.state.infoModalOpen}
          messageList={KPI_INFO.groups}
          desiredClassName={"kpi-info"}
          onClose={this.handleInfoClose.bind(this)}
          error={false}
        />
        <div className="submissions-kpi-data-list__explanatory">
          {(submissionsType === 'New' && allAccurate) ? this.renderExplanatoryText() : null}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="submissions-kpi-data-list">
        <div className="submissions-kpi-data-list__inner-wrap">
          {Object.keys(this.props.submissions).length > 0 ?
            this.renderData()
            :
            <div className="submissions-kpi-data-list__no-data">
              No Data
            </div>
          }
        </div>
      </div>
    );
  }
}

SubmissionsKpiDataList.propTypes = {
  submissions: PropTypes.object.isRequired,
  mtd: PropTypes.bool.isRequired,
  submissionsType: PropTypes.string.isRequired
};

export default SubmissionsKpiDataList;
